<template>
  <footer class="footer">
    <mq-layout mq="mobile">
      <!--<instagram />-->
    </mq-layout>
    <div class="content has-text-centered">
      <p>
        <strong>Copyright ©2006-{{ currentYear }} AHLPoker.com </strong>All rights reserved.
      </p>
      <p>
        <small><a href="https://www.facebook.com/Zeggle/">Website and Programming created for AHL by Zeggle inc.</a></small>
      </p>
      <p>
        <a
          class="icon"
          href="https://www.facebook.com/AHLPokerMain/"
          target="_blank"
        >
          <i
            class="fab fa-facebook-square"
            aria-hidden="true"
          />
        </a>
        <a
          class="icon"
          href="https://www.instagram.com/ahl_poker/"
          target="_blank"
        >
          <i
            class="fab fa-instagram"
            aria-hidden="true"
          />
        </a>
      </p>
    </div>
  </footer>
</template>

<script>
  import Instagram from './sidebar/Instagram.vue'
  export default {
    name: 'Footer',
    components: {
      Instagram
    },
    data () {
      return {
        year: 2017
      }
    },
    computed: {
      currentYear () {
        let now = new Date()
        return now.getFullYear()
      }
    },
    methods: {}
  }
</script>
